"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Super/SuperUserScreen.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _log = require('shared/log');
var _Name = require('web/components/Name'); var _Name2 = _interopRequireDefault(_Name);
var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _alertReducer = require('shared/reducers/alertReducer');
var _SuperTableTR = require('web/components/Super/SuperTableTR'); var _SuperTableTR2 = _interopRequireDefault(_SuperTableTR);
var _Tt = require('web/screens/Super/Tt'); var _Tt2 = _interopRequireDefault(_Tt);
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _SuperUserTeamsTable = require('web/components/Super/SuperUserTeamsTable'); var _SuperUserTeamsTable2 = _interopRequireDefault(_SuperUserTeamsTable);
var _MoreToggle = require('web/components/RightSide/Header/MoreToggle'); var _MoreToggle2 = _interopRequireDefault(_MoreToggle);
var _Tooltip = require('web/components/Tooltip');
var _supportChat = require('web/screens/Super/supportChat');
var _user = require('shared/selectors/user');
var _hooks = require('web/services/hooks');













const RelationshipRow = ({ org, relationship }) => {
  return (
    _react2.default.createElement(_SuperTableTR2.default, { to: `/super/orgs/${org.OrgKey}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}
      , _react2.default.createElement('td', { className: "uuid", __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}, org.OrgKey)
      , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 34}}, org.Name)
      , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 35}}, relationship.Title)
      , _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 36}}, relationship.Type)
      , _react2.default.createElement('td', { className: "bool", __self: this, __source: {fileName: _jsxFileName, lineNumber: 37}}, relationship.Pending ? 'yes' : 'no')
    )
  )
}

// Lists the keys newest-first after the first, as the class's reduce did.
const joinKeys = (keys) => keys.reduce((acc, key, i) => {
  if (i === 0) {
    return key
  }
  return key + ", " + acc
}, "")



// Memoized, as connect() was.
const SuperUserScreen = _react.memo.call(void 0, function SuperUserScreen ({ match }) {
  const currentUser = _hooks.useAppSelector.call(void 0, _user.selectCurrentUser)
  const userKey = match.params.userKey

  const [user, setUser] = _react.useState(undefined)
  const [orgs, setOrgs] = _react.useState({})
  const [v5User, setV5User] = _react.useState(undefined)
  const [deleteModalOpen, setDeleteModalOpen] = _react.useState.call(void 0, false)
  const [deletePatientModalOpen, setDeletePatientModalOpen] = _react.useState.call(void 0, false)
  const [impersonateModalOpen, setImpersonateModalOpen] = _react.useState.call(void 0, false)
  const [impersonatePending, setImpersonatePending] = _react.useState.call(void 0, false)

  // Bumped on every load; an answer from an older load is ignored, so a slow
  // answer for a previous user key can't replace the current user.
  const loadId = _react.useRef.call(void 0, 0)

  const reload = _react.useCallback.call(void 0, () => {
    const id = ++loadId.current
    _client2.default.send('SuperUserProfile', { UserKey: userKey })
      .then((results) => {
        if (id !== loadId.current) return
        setUser(results.Users[userKey])
        setOrgs(results.Orgs)
      }).catch(_log.log.error)

    // Use this newer command to get teams for non-deleted users
    _client2.default.send('SUPER_GetUsers_V5', { UserKeys: [userKey] }).then((r) => {
      if (id !== loadId.current) return
      if (r.Users) {
        setV5User(r.Users[userKey])
      }
    }).catch(_log.log.error)
  }, [userKey])

  // When the user key in the URL changes (the route keeps this screen
  // mounted across keys), clear the previous user before paint so it is
  // never shown under the new key.
  const prevUserKey = _react.useRef.call(void 0, userKey)
  _react.useLayoutEffect.call(void 0, () => {
    if (prevUserKey.current === userKey) return
    prevUserKey.current = userKey
    setUser(undefined)
    setOrgs({})
    setV5User(undefined)
    setDeleteModalOpen(false)
    setDeletePatientModalOpen(false)
    setImpersonateModalOpen(false)
  }, [userKey])

  // Loads on mount and again whenever the user key changes.
  _react.useEffect.call(void 0, () => {
    reload()
  }, [reload])

  // Deletes a staff user. The server refuses a patient user and says to use
  // Delete patient user.
  const deleteUser = (key) => {
    _client2.default.send('SuperDeleteUser', { UserKey: key })
      .then(() => {
        _actions2.default.pushAlert("Success", "Successfully deleted user", _alertReducer.AlertTypes.SUCCESS)
        setDeleteModalOpen(false)
        reload()
      }).catch((err) => {
        const message = _optionalChain([err, 'optionalAccess', _ => _.Error])
        _actions2.default.pushAlert('Error', typeof message === 'string' ? message : "Couldn't delete the user", _alertReducer.AlertTypes.ERROR)
        _log.log.error(err)
      })
  }

  // Completes a patient's Delete account request (RUNBOOK.md, Account
  // deletion requests). The server refuses a staff user and says why.
  const deletePatientUser = (key) => {
    _client2.default.send('SuperDeletePatientUser', { UserKey: key })
      .then(() => {
        _actions2.default.pushAlert('Success', 'Deleted the patient user', _alertReducer.AlertTypes.SUCCESS)
        setDeletePatientModalOpen(false)
        reload()
      }).catch((err) => {
        const message = _optionalChain([err, 'optionalAccess', _2 => _2.Error])
        _actions2.default.pushAlert('Error', typeof message === 'string' ? message : "Couldn't delete the patient user", _alertReducer.AlertTypes.ERROR)
        _log.log.error(err)
      })
  }

  const openDeleteUser = () => setDeleteModalOpen(true)
  const closeDeleteUser = () => setDeleteModalOpen(false)
  const openImpersonateUser = () => setImpersonateModalOpen(true)

  const closeImpersonateUser = () => {
    if (impersonatePending) return
    setImpersonateModalOpen(false)
  }

  const impersonateUser = () => {
    if (impersonatePending || !user) return
    setImpersonatePending(true)
    _client2.default.superImpersonate(user.UserKey)
      .then(() => {
        window.location.href = '/'
      })
      .catch(err => {
        _actions2.default.pushAlert("Error", "Failed to log in as user", _alertReducer.AlertTypes.ERROR)
        setImpersonateModalOpen(false)
        setImpersonatePending(false)
        _log.log.error(err)
      })
  }

  const openSupportChat = () => {
    if (!user) return
    _supportChat.openSupportChatWithUser.call(void 0, user.UserKey, currentUser.UserKey)
      .catch(err => {
        _actions2.default.pushAlert("Error", "Failed to open support chat", _alertReducer.AlertTypes.ERROR)
        _log.log.error(err)
      })
  }

  if (!user) return null

  const relationships = Object.values(user.Relationships || {}).map(rel => (
    _react2.default.createElement(RelationshipRow, { relationship: rel, org: orgs[rel.OrgKey] || {}, key: rel.OrgKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 173}} )
  ))
  const canOpenSupportChat = user.Activated && !user.Deleted

  const phones = user.Phones ? joinKeys(Object.keys(user.Phones)) : ""
  const emails = user.Emails ? joinKeys(Object.keys(user.Emails)) : ""

  return (
    _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 181}}

      , _react2.default.createElement(_Modal2.default, {
        isOpen: deleteModalOpen,
        onClose: closeDeleteUser,
        title: "Delete user" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 183}}

        , _react2.default.createElement(_Modal.ModalSubtitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 188}}, "Are you sure you want to mark this user as deleted?"
                    , ' ', "They will be removed from any organizations they belong to."

        )
        , _react2.default.createElement(_Modal.ModalControls, {
          secondaryBtnLabel: "Cancel",
          onSecondaryBtnClick: closeDeleteUser,
          primaryBtnTheme: "danger",
          primaryBtnLabel: "Delete",
          onPrimaryBtnClick: () => deleteUser(user.UserKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 192}}
        )
      )

      , _react2.default.createElement(_Modal2.default, {
        isOpen: deletePatientModalOpen,
        onClose: () => setDeletePatientModalOpen(false),
        title: "Delete patient user"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 201}}

        , _react2.default.createElement(_Modal.ModalSubtitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 206}}, "Patient: "
           , _react2.default.createElement('strong', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 207}}, _react2.default.createElement(_Name2.default, { user: user, __self: this, __source: {fileName: _jsxFileName, lineNumber: 207}} )), ".", ' ', "This deletes their sign-in: their phone and email logins, links to clinic records, photo, push devices and sessions. Each clinic keeps its patient record and chat history, so if they sign in again later with the same phone or email, they get a new account that sees those messages again. This can't be undone."





        )
        , _react2.default.createElement(_Modal.ModalControls, {
          secondaryBtnLabel: "Cancel",
          onSecondaryBtnClick: () => setDeletePatientModalOpen(false),
          primaryBtnTheme: "danger",
          primaryBtnLabel: "Delete patient" ,
          onPrimaryBtnClick: () => deletePatientUser(user.UserKey), __self: this, __source: {fileName: _jsxFileName, lineNumber: 214}}
        )
      )

      , _react2.default.createElement(_Modal2.default, {
        isOpen: impersonateModalOpen,
        onClose: closeImpersonateUser,
        title: "Login as user"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 223}}

        , _react2.default.createElement(_Modal.ModalSubtitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 228}}, "This browser will switch to "
               , user.Name, "'s account. To get back to your own account, log out and sign in again with your password."

        )
        , _react2.default.createElement(_Modal.ModalControls, {
          secondaryBtnLabel: "Cancel",
          onSecondaryBtnClick: closeImpersonateUser,
          primaryBtnLabel: "Login as user"  ,
          onPrimaryBtnClick: impersonateUser,
          isPrimaryLoading: impersonatePending,
          isPrimaryEnabled: !impersonatePending, __self: this, __source: {fileName: _jsxFileName, lineNumber: 232}}
        )
      )

      , _react2.default.createElement('div', { className: "superuser--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 242}}
        , _react2.default.createElement('div', { className: "superuser--section-heading", __self: this, __source: {fileName: _jsxFileName, lineNumber: 243}}
          , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 244}}, "Properties")
          ,  canOpenSupportChat ? (
            _react2.default.createElement(_MoreToggle2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 246}}
              , _react2.default.createElement(_Tooltip.TooltipMenuItem, {
                iconSrc: "/assets/icons/video/message-black.svg",
                label: "Open support chat"  ,
                onClick: openSupportChat, __self: this, __source: {fileName: _jsxFileName, lineNumber: 247}}
              )
            )
          ) : null 
        )
        , _react2.default.createElement('dl', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 255}}
          , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 256}}, "User Key" )
          , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 257}}, _react2.default.createElement(_Tt2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 257}}, user.UserKey))
          , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 258}}, "Name")
          , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 259}}, _react2.default.createElement(_Name2.default, { user: user, __self: this, __source: {fileName: _jsxFileName, lineNumber: 259}} ))
          ,  emails ? _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 260}}, "Email Addresses" ) : null 
          ,  emails ? _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 261}}, emails) : null 
          ,  phones ? _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 262}}, "Phone Numbers" ) : null 
          ,  phones ? _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 263}}, phones) : null
          , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 264}}, "Activated")
          , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 265}}, user.Activated ? 'yes' : 'no')
          , _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 266}}, "Deleted")
          , _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 267}}, user.Deleted ? 'yes' : 'no')
          ,  user.InvitedByOrgAdminKey ? _react2.default.createElement('dt', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 268}}, "Invited By" ) : null 
          ,  user.InvitedByOrgAdminKey ? _react2.default.createElement('dd', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 269}}, _react2.default.createElement(_Tt2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 269}}, user.InvitedByOrgAdminKey)) : null 
        )
        , _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 271}}
          , _react2.default.createElement('button', { onClick: openImpersonateUser, disabled: !!user.Deleted, className: "blmh-button", __self: this, __source: {fileName: _jsxFileName, lineNumber: 272}}, "Login as user"  ), ' '
          , _react2.default.createElement('button', { onClick: () => openDeleteUser(), disabled: !!user.Deleted, className: "blmh-button red" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 273}}, "Delete"), ' '
          , _react2.default.createElement('button', { onClick: () => setDeletePatientModalOpen(true), disabled: !!user.Deleted, className: "blmh-button red" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 274}}, "Delete patient user"  )
        )
      )

      , _react2.default.createElement('div', { className: "superuser--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 278}}
        , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 279}}, "Organizations")
        , _react2.default.createElement('table', { className: "super--table", __self: this, __source: {fileName: _jsxFileName, lineNumber: 280}}
          , _react2.default.createElement('thead', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 281}}
            , _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 282}}
              , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 283}}, "Org Key" )
              , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 284}}, "Name")
              , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 285}}, "Title")
              , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 286}}, "Role")
              , _react2.default.createElement('th', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 287}}, "Pending")
            )
          )
          , _react2.default.createElement('tbody', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 290}}
            , relationships
          )
        )
      )

      , _react2.default.createElement('div', { className: "superuser--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 296}}
        , _react2.default.createElement('h4', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 297}}, "Teams")
        ,  v5User ? _react2.default.createElement(_SuperUserTeamsTable2.default, { teams: v5User.Teams, __self: this, __source: {fileName: _jsxFileName, lineNumber: 298}} ) : _react2.default.createElement('p', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 298}}, "None") 
      )

    )
  )
})

exports. default = SuperUserScreen
